<template>
  <div class="sbp">
    <!-- Note de contexte -->
    <div v-if="!existingStrategy" class="ov-hint sbp-note">
      Les champs marqués d'un astérisque (<span class="ov-required">*</span>) sont obligatoires.
    </div>
    <div v-else class="ov-note sbp-note">
      <v-icon small color="#159e72">mdi-check-circle-outline</v-icon>
      <span>Modifiez les valeurs ci-dessous pour mettre à jour la stratégie active.</span>
    </div>

    <div class="ov-row">
      <!-- Prix du kilo -->
      <div class="ov-field">
        <label class="ov-label">Prix du kilo<span class="ov-required">*</span></label>
        <div class="ov-input-suffix">
          <input
            type="number"
            min="0"
            v-model.number="$v.strategieBagagePoidsModel.data.strategieBagagePoidsDTO.prixKilo.$model"
            class="ov-input"
            :class="{ 'is-invalid': $v.strategieBagagePoidsModel.data.strategieBagagePoidsDTO.prixKilo.$error }"
            placeholder="0"
            @change="markAsModified"
          />
          <span>FCFA / kg</span>
        </div>
        <div v-if="$v.strategieBagagePoidsModel.data.strategieBagagePoidsDTO.prixKilo.$error" class="ov-error">
          Le prix du kilo est obligatoire.
        </div>
      </div>

      <!-- Kilos gratuits -->
      <div class="ov-field">
        <label class="ov-label">Kilo(s) gratuit(s)<span class="ov-required">*</span></label>
        <div class="ov-input-suffix">
          <input
            type="number"
            min="0"
            v-model.number="$v.strategieBagagePoidsModel.data.strategieBagagePoidsDTO.nombreKiloNonTaxable.$model"
            class="ov-input"
            :class="{ 'is-invalid': $v.strategieBagagePoidsModel.data.strategieBagagePoidsDTO.nombreKiloNonTaxable.$error }"
            placeholder="0"
            @change="markAsModified"
          />
          <span>kg</span>
        </div>
        <div v-if="$v.strategieBagagePoidsModel.data.strategieBagagePoidsDTO.nombreKiloNonTaxable.$error" class="ov-error">
          Le nombre de kilos gratuits est obligatoire.
        </div>
      </div>
    </div>

    <div v-if="!existingStrategy || isModified" class="sbp-actions">
      <button v-if="!existingStrategy" type="button" class="ov-btn ov-btn--secondary" @click="reinitializeStrategyPoidsModel">
        <v-icon small>mdi-refresh</v-icon>
        Réinitialiser
      </button>
      <button
        type="button"
        class="ov-btn ov-btn--primary"
        @click="existingStrategy ? updateStrategieParPoids() : creerStrategieParPoids()"
      >
        <v-icon small>{{ existingStrategy ? 'mdi-update' : 'mdi-content-save-outline' }}</v-icon>
        {{ existingStrategy ? 'Mettre à jour' : 'Enregistrer' }}
      </button>
    </div>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="56" color="#159e72"></v-progress-circular>
    </v-overlay>
    <v-alert ref="errorAlert" class="myalert" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import {
  API_CREATE_STRATEGIE_BAGAGE,
  API_UPDATE_STRATEGIE_BAGAGE,
  HEADERS,
} from "@/components/globalConfig/globalConstConfig";
import axios from "axios";
import $ from "jquery";
export default {
  name: "StrategieBagagePoids",
  props: {
    errorMessage: String,
    typeStrategie: String,
    existingStrategy: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      overlay: false,
      errorMsg: null,
      isModified: false,

      strategieBagagePoidsModel: {
        data: {
          designation: null,
          typeStrategieBagageDesignation: null,
          strategieBagagePoidsDTO: {
            designation: null,
            prixKilo: null,
            nombreKiloNonTaxable: null,
          },
        },
      },
    };
  },

  validations: {
    strategieBagagePoidsModel: {
      data: {
        strategieBagagePoidsDTO: {
          prixKilo: {
            required,
          },

          nombreKiloNonTaxable: {
            required,
          },
        },
      },
    },
  },

  methods: {
    // Affiche l'alerte de CE widget. showErrorMessage() cible toutes les alertes
    // .alert-error de la page et ferait apparaître celle du parent, restée vide.
    showError() {
      const el = this.$refs.errorAlert && this.$refs.errorAlert.$el;
      if (!el) return;
      $(el).fadeIn();
      setTimeout(() => $(el).fadeOut(), 4000);
    },

    markAsModified() {
      this.isModified = true;
    },

    // Reinitialize strategie Poids model
    reinitializeStrategyPoidsModel() {
      this.strategieBagagePoidsModel.data.strategieBagagePoidsDTO.prixKilo = 0;
      this.strategieBagagePoidsModel.data.strategieBagagePoidsDTO.nombreKiloNonTaxable = 0;
    },

    // CREER STRATEGIE PAR POIDS
    async creerStrategieParPoids() {
      this.$v.$touch();
      if (this.$v.strategieBagagePoidsModel.$invalid) {
        this.errorMsg =
          "Veuillez saisir correctement les champs obligatoires !!!";
        this.showError();
      } else {
        this.overlay = true;
        //this.strategieBagagePoidsModel.data.designation = this.typeStrategie;
        this.strategieBagagePoidsModel.data.typeStrategieBagageDesignation =
          this.typeStrategie;
        //this.strategieBagagePoidsModel.data.strategieBagagePoidsDTO.designation =
          //this.typeStrategie;

        await axios
          .post(API_CREATE_STRATEGIE_BAGAGE, this.strategieBagagePoidsModel, {
            headers: HEADERS(this.$store.state.userAuthentified.token),
          })
          .then((response) => {
            if (response.status == 200) {
              if (response.data.status.code == 800) {
                // Émettre un événement pour recharger la stratégie dans le parent
                this.$emit('strategie-created', response.data.status.message);
              } else {
                this.errorMsg = response.data.status.message;
                this.showError();
              }
            } else {
              this.errorMsg = "Erreur , opération de création impossible";
              this.showError();
            }
          })
          .catch((e) => {
            this.errorMsg = e;
            this.showError();
          })
          .finally(() => {
            this.overlay = false;
            this.reinitializeStrategyPoidsModel();
          });
      }
    },

    // METTRE À JOUR STRATEGIE PAR POIDS
    async updateStrategieParPoids() {
      this.$v.$touch();
      if (this.$v.strategieBagagePoidsModel.$invalid) {
        this.errorMsg =
          "Veuillez saisir correctement les champs obligatoires !!!";
        this.showError();
      } else {
        this.overlay = true;

        // Construire le payload de mise à jour selon le format attendu par le backend
        const updatePayload = {
          data: {
            id: this.strategieBagagePoidsModel.data.id,
            strategieBagagePoidsDTO: {
              id: this.strategieBagagePoidsModel.data.strategieBagagePoidsDTO.id,
              prixKilo: this.strategieBagagePoidsModel.data.strategieBagagePoidsDTO.prixKilo,
              nombreKiloNonTaxable: this.strategieBagagePoidsModel.data.strategieBagagePoidsDTO.nombreKiloNonTaxable
            }
          }
        };

        await axios
          .put(API_UPDATE_STRATEGIE_BAGAGE, updatePayload, {
            headers: HEADERS(this.$store.state.userAuthentified.token),
          })
          .then((response) => {
            if (response.status == 200) {
              if (response.data.status.code == 800) {
                this.isModified = false;
                // Émettre un événement pour recharger la stratégie dans le parent
                this.$emit('strategie-updated', response.data.status.message);
              } else {
                this.errorMsg = response.data.status.message;
                this.showError();
              }
            } else {
              this.errorMsg = "Erreur , opération de mise à jour impossible";
              this.showError();
            }
          })
          .catch((e) => {
            this.errorMsg = e;
            this.showError();
          })
          .finally(() => {
            this.overlay = false;
          });
      }
    },
  },

  mounted() {
    // Si une stratégie existante est fournie, charger ses données
    if (this.existingStrategy) {
      this.strategieBagagePoidsModel.data = JSON.parse(JSON.stringify(this.existingStrategy));
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/admin/ui";

.sbp {
  font-family: "Montserrat", sans-serif;

  input {
    font-family: "Montserrat", sans-serif;
  }
}

.sbp-note {
  margin: 0 0 18px;
}

.ov-input-suffix .ov-input {
  padding-right: 84px;
}

.sbp-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid $ov-line;
}

@media (max-width: 760px) {
  .sbp-actions .ov-btn {
    flex: 1;
  }
}
</style>
